import styled from 'styled-components';
import HomeShortcut from './HomeShortcut';
import impexpSVG from '../../resources/images/home/shortcuts/noun-custom-clearance-4649289-FFFFFF.svg';
import drawbackSVG from '../../resources/images/home/shortcuts/noun-monetary-turn-214819-FFFFFF.svg';
import requirementSVG from '../../resources/images/home/shortcuts/noun-requirement-2209179-FFFFFF.svg';
import quarantineSVG from '../../resources/images/home/shortcuts/noun-quarantine-3985410-FFFFFF.svg';
import ftaSVG from '../../resources/images/home/shortcuts/noun-trade-1290817-FFFFFF.svg';
import aeoSVG from '../../resources/images/home/shortcuts/noun-authorize-1949799-FFFFFF.svg';
import customslegalSVG from '../../resources/images/home/shortcuts/noun-legal-2492909-FFFFFF.svg';
import scmSVG from '../../resources/images/home/shortcuts/supply-chain-FFFFFF.svg';
import ascpSVG from '../../resources/images/home/shortcuts/platform-FFFFFF.svg';
import { languageStore } from '../../state/language';
const HomeShortcuts = () => {
  const {language} = languageStore();

    return (<Nav aria-label="업무분야 바로가기">
        <HomeShortcut title={language === "EN" ? "DECLARATION" : "수출입통관"} url="/impexp" icon={impexpSVG} />
        <HomeShortcut title={language === "EN" ? "DRAWBACK" : "환급"} url="/drawback" icon={drawbackSVG} />
        <HomeShortcut title="요건" url="/requirement" icon={requirementSVG}/>
        <HomeShortcut title="검역" url="/quarantine" icon={quarantineSVG} />
        <HomeShortcut title="FTA" url="/consulting/fta" icon={ftaSVG} />
        <HomeShortcut title="AEO" url="/consulting/aeo" icon={aeoSVG} />
        <HomeShortcut title="관세심사" url="/legal/customs" icon={customslegalSVG} />
        <HomeShortcut title={language === "EN" ? "SUPPLY CHAIN" : "공급망"} url="/scm" icon={scmSVG} />
        <HomeShortcut title="ASCP" url="/it/ascp" icon={ascpSVG} />
        </Nav>)
}
export default HomeShortcuts;
const Nav = styled.nav`
display: grid;
grid-template-columns: repeat(9, minmax(0, 1fr));
border-radius: 1.25rem;
overflow: hidden;
background-color: rgba(255, 255, 255, 0.08);
border: 1px solid rgba(255, 255, 255, 0.16);
backdrop-filter: blur(14px);
-webkit-backdrop-filter: blur(14px);
@media (max-width: 991px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
`;
